import { Heading, Stack } from '@etg/wings';
import { ReactComponent as AppStore } from '@eti/assets/logos/store-badges/appstore-badge.svg';
import { ReactComponent as GooglePlayStore } from '@eti/assets/logos/store-badges/googleplay-badge.svg';
import { css } from '@eti/styles';
import { useProperty, useTranslation } from '@eti/providers';

const badgeStyle = css`
  height: 44px;
  width: auto;
`;

const linkStyle = css`
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.7;
    transition: 0.3s;
  }
`;

const FooterDownloadApps = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const appStoreAriaLabel = t('ScreenReader.Order.DownloadApp.AppStoreAriaLabel');
  const playStoreAriaLabel = t('ScreenReader.Order.DownloadApp.PlayStoreAriaLabel');

  const appStoreHref = p('Order.DownloadApp.AppStoreLink');
  const playStoreHref = p('Order.DownloadApp.PlayStoreLink');

  return (
    <Stack data-testid="footerDownloadApps-links" spacing={24}>
      <Heading level={2}>{t('Footer.DownloadApps.Text')}</Heading>
      <a
        aria-label={appStoreAriaLabel}
        className={linkStyle}
        data-testid="appStore-download-app-link"
        href={appStoreHref}
        rel="noreferrer"
        target="_blank"
      >
        <AppStore className={badgeStyle} />
      </a>
      <a
        aria-label={playStoreAriaLabel}
        className={linkStyle}
        data-testid="googlePlay-download-app-link"
        href={playStoreHref}
        rel="noreferrer"
        target="_blank"
      >
        <GooglePlayStore className={badgeStyle} />
      </a>
    </Stack>
  );
};

export default FooterDownloadApps;
